import PageComponent from '../base/PageComponent';

export default class Filter extends PageComponent {
    init() {
        this.bindForm();
    }

    bindForm() {
        if (typeof this.onFilter === 'function') {
            this.onFilter(this.getFilterData());

            this.addEvent('.field', 'change', (e) => {
                e.preventDefault();
                //CM-99 only allow 1 status at a time
                if($(e.target).hasClass('checkbox')){
                    $(e.target).closest('#Status').find('.checkbox').prop('checked', false);
                    $(e.target).prop('checked', true);
                }
                this.onFilter(this.getFilterData());
            });
        }
    }

    getFilterData() {
        return this.childElements('form').serialize();
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/Filter.js